const SalesChannelModalFooter = ({ children }) => {
  return (
    <div className="relative p-4 border-t border-gray-200">
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
};

export default SalesChannelModalFooter;
